import { render, staticRenderFns } from "./cam-requests.vue?vue&type=template&id=28d6ee9a"
import script from "./cam-requests.vue?vue&type=script&lang=js"
export * from "./cam-requests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports